module.exports = __webpack_public_path__ + "img/OP.d19e1333.png";